import { render, staticRenderFns } from "./OdocPrognosInput.vue?vue&type=template&id=2c0d3798"
import script from "./OdocPrognosInput.vue?vue&type=script&lang=js"
export * from "./OdocPrognosInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports